import { useTranslation } from 'react-i18next'

import { QA_NAME_SAVE_BTN } from '../../../../../constants/qa'
import { SERVER_NON_FIELD_ERROR_KEY } from '../../../../../constants/validation'
import { FormModal } from '../../../../Form'
import { patchMockApplicant } from '../../../../RentalPortalApplicant'

import { QA_NAME_APPLICANT_RESPONSIBLE_MANAGER_MODAL } from './ApplicantResponsibleManagerModal.constants'
import {
  getApplicantResponsibleManagerPayload,
  getApplicantResponsibleManagerValidationSchema,
} from './ApplicantResponsibleManagerModal.utils'
import { ApplicantResponsibleManagerModalFields } from './ApplicantResponsibleManagerModalFields'

function ApplicantResponsibleManagerModal({
  applicantId,
  initialValues,
  onClose,
  onSave,
}) {
  const { t } = useTranslation()

  function handleSubmit({ setErrors, setSubmitting, values }) {
    return patchMockApplicant(
      applicantId,
      getApplicantResponsibleManagerPayload(values)
    )
      .then(onSave)
      .catch(() => {
        setSubmitting(false)

        setErrors({
          [SERVER_NON_FIELD_ERROR_KEY]: t(
            'RentalPortal.ListingProfileResponsibleManagerSaveErrorKey'
          ),
        })
      })
  }

  return (
    <FormModal
      Fields={ApplicantResponsibleManagerModalFields}
      containerProps={{ qaName: QA_NAME_APPLICANT_RESPONSIBLE_MANAGER_MODAL }}
      formBodyProps={{
        submitQaName: QA_NAME_SAVE_BTN,
        withNotifications: true,
      }}
      formTitle='RentalPortal.ListingProfileResponsibleManagerModalTitleKey'
      initialValues={initialValues}
      validationSchema={getApplicantResponsibleManagerValidationSchema({
        initialValues,
      })}
      onClose={onClose}
      onSubmit={handleSubmit}
    />
  )
}

export default ApplicantResponsibleManagerModal
